import { Stack } from '@mui/material';
import React, { useState } from 'react';
import { ContactCaptureSettings, ContactCaptureType } from '../../types';
import { ContactCapturePreviewCanvas } from './ContactCapturePreviewCanvas';
import { ContactCapturePreviewToolbar, PreviewState } from './ContactCapturePreviewToolbar';

type Props = {
  settings: ContactCaptureSettings;
  type: ContactCaptureType;
  consentText: string;
};

export const ContactCapturePreview = ({ settings, type, consentText }: Props) => {
  const [previewState, setPreviewState] = useState<PreviewState>('form');

  return (
    <Stack
      spacing={1.5}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        boxSizing: 'border-box',
        p: { xs: 1.5, md: 2 },
      }}
    >
      <ContactCapturePreviewToolbar
        previewState={previewState}
        type={type}
        onPreviewStateChange={setPreviewState}
      />
      <ContactCapturePreviewCanvas
        consentText={consentText}
        previewState={previewState}
        settings={settings}
        type={type}
      />
    </Stack>
  );
};
